function ChowsAndBlogsCitations({ citation }: any) {
  return (
    <div>
      <a
        href={citation.link}
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-pointer text-left block  text-blue-600 hover:underline"
      >
        {citation.title} <i> by {citation.author}</i>
      </a>
    </div>
  );
}

export default ChowsAndBlogsCitations;
